var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRechargeWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.03,
    height: 18.056,
    viewBox: "0 0 18.03 18.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recharge-white",
    transform: "translate(-481.94 -4578.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(482.699 4578.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M4.172,16.307l.97.975a8.22,8.22,0,0,0,11.674-.046,8.335,8.335,0,0,0,2.345-6.76M17.747,6.53l-.969-.976A8.22,8.22,0,0,0,5.1,5.582a8.333,8.333,0,0,0-2.356,6.76",
    transform: "translate(-2.699 -3.136)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "flash",
    d: "M81.762,23.324a.281.281,0,0,1-.277-.33v0l.431-2.366H80.247a.245.245,0,0,1-.191-.4l3.359-4.153a.283.283,0,0,1,.5.21.084.084,0,0,1,0,.014l-.432,2.367h1.668a.245.245,0,0,1,.191.4l-3.36,4.153A.283.283,0,0,1,81.762,23.324Z",
    transform: "translate(-74.393 -11.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M18.8,4.727,18.6,7.6,15.67,7.461M3.234,18.332l.2-2.875,2.926.141",
    transform: "translate(479.943 4575.495)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeWhiteIcon);
export default __webpack_public_path__ + "static/media/recharge-white-icon.59f7a1718f08e7c95664cf001d4009c4.svg";
export { ForwardRef as ReactComponent };